import { sessionStorageDisabledConfirmationsKey } from "variables";

export const isDeleteModalDisabled = (type: string) =>
  sessionStorage
    .getItem(sessionStorageDisabledConfirmationsKey)
    ?.includes(type);
